export default function titleString (that) {
  let pageKey = that.pageKey || that.page.key
  let filterKeys = Object.keys(that.filters)
  let riskRatio = pageKey === 'accidents' ? 'Risk Ratio of ' + that.getLabelForSelectedOption('question') : ''
  let measureText = filterKeys.includes('measure') ? that.getLabelForSelectedOption('measure') : ''
  if (measureText !== '' && (that.chart.props.average || (pageKey === 'exposure' && that.getFilter('metric') !== 'boats'))) {
    measureText = 'Average Number'
  }
  let addendum = ''

  switch (pageKey) {
    case 'safety':
      addendum = ' of Boats '
      break
    case 'accidents':
      addendum = ' '
      break
    default:
      addendum = ' of '
      break
  }
  measureText += addendum
  let metricText = filterKeys.includes('metric') ? that.getLabelForSelectedOption('metric') + ' ' : ''
  let chartTitle = that.chart.title ? that.chart.title : ''
  let boatType = ''
  if (filterKeys.includes('filter1boattype') && (that.isFilterDirty('filter1boattype') || pageKey === 'ownership')) {
    boatType = that.getLabelForSelectedOption('filter1boattype')
  }
  if (filterKeys.includes('filter1boatbin') && that.isFilterDirty('filter1boatbin')) {
    boatType = that.getLabelForSelectedOption('filter1boatbin')
  }

  let stateOrRegion = ''
  if (filterKeys.includes('filter1stateorregion') && that.isFilterDirty('filter1stateorregion')) {
    stateOrRegion = that.getLabelForSelectedOption('filter1stateorregion')
  }
  if (filterKeys.includes('filter2stateorregion') && that.isFilterDirty('filter2stateorregion')) {
    stateOrRegion = that.getLabelForSelectedOption('filter2stateorregion')
  }
  if (filterKeys.includes('filter1region') && that.isFilterDirty('filter1region')) {
    stateOrRegion = that.getLabelForSelectedOption('filter1region')
  }

  if (filterKeys.includes('filter2state') && that.isFilterDirty('filter2state')) {
    stateOrRegion = that.getLabelForSelectedOption('filter2state')
  }

  if (boatType || stateOrRegion) {
    chartTitle += ': '
  }
  if (boatType && stateOrRegion) {
    boatType += ', '
  }
  let titleString = riskRatio + measureText + metricText + chartTitle + boatType + stateOrRegion
  if (pageKey === 'accidents') {
    titleString = riskRatio + measureText + chartTitle + ' Per 100 Million ' + metricText + boatType + stateOrRegion
  }
  // safety other, replacing "and answered yes" with question-specific text
  if (that.chart && that.chart.key && that.chart.key.includes('allboats')) {
    const equip = that.getFilter('question').toUpperCase()
    titleString = titleString.replace('And Answered Yes', `with ${equip} Aboard`)
  }

  // exposure, variable boat types depending on metric
  if (pageKey === 'exposure') {
    let boattype = that.getFilter('metric').includes('boat') ? 'Of Registration or Storage' : 'Of Operation'
    if (that.chart && that.chart.key && that.chart.key.includes('of_residence')) {
      titleString = titleString.replace('Of Residence', boattype)
    }
  }
  return titleString
}
